export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_manage_advanced',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_assignment_manage',
  'conversation_status_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'knowledge_base_content',
  'citizen_complaint_manage',
  'citizen_history_manage',
  'audit_log_manage',
  'multi_team_notes',
  'copilot_access',
  'team_scope',
  'general_search_manage',
  'agent_manage',
];

// 69.1.34d — permiso requerido para usar la búsqueda general. Admin siempre.
export const GENERAL_SEARCH_PERMISSIONS = 'general_search_manage';

// Permisos que habilitan ver el módulo de búsqueda en el dashboard.
// Admin SIEMPRE puede. Agent regular requiere custom_role con general_search_manage.
export const SEARCH_VIEW_PERMISSIONS = [
  'administrator',
  GENERAL_SEARCH_PERMISSIONS,
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_manage_advanced',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';
export const MANAGE_ALL_CONVERSATION_ADVANCED_PERMISSIONS =
  'conversation_manage_advanced';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const AUDIT_LOG_PERMISSIONS = 'audit_log_manage';

export const CONVERSATION_STATUS_PERMISSIONS = 'conversation_status_manage';

// Permissions that implicitly grant access to view all conversation statuses
export const ALL_STATUS_PERMISSIONS = [
  ...ROLES,
  'conversation_manage',
  'conversation_manage_advanced',
  'conversation_status_manage',
];

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
